import axios from 'axios';

const hasValidStripeMlsProductId = async (): Promise<boolean> => {
  const { data } = await axios.get('/answering/is_answering_enhanced_p1');

  return data;
};

export default hasValidStripeMlsProductId;
